module.exports = __webpack_public_path__ + "static/img/img_2.fdbb5246.jpg";